import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import user1 from "../assets/img/user/user1.png";
import user2 from "../assets/img/user/user2.png";
import Search from "../components/search/Search";
import ClientProfile from "../components/Tab/ClientProfile";
import RepairCredit from "../pages/RepairCredit";
import CreditAgent from "../components/ui/CreditAgent"

export default function ClientsDashboard() {
  const [activeTab, setActiveTab] = useState(0);
  const users = [
    {
      id: 1,
      name: "Adam Smith",
      messageCount: 10,
      creditScore: 720,
      status: "Available for Funding",
      available: true,
      profileImage: user1,
    },
    {
      id: 2,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 3,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 4,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 5,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 6,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 7,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 8,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
    {
      id: 9,
      name: "Emily Johnson",
      messageCount: 5,
      creditScore: 680,
      status: "Not Available for Funding",
      available: false,
      profileImage: user2,
    },
  ];

  const tabs = [
    {
      title: "Profile",
      content: <ClientProfile />,
    },
    {
      title: "Repair Credit",
      content: <RepairCredit />,
    },
    {
      title: "Chat",
      content: <CreditAgent />,
    },
  ];

  return (
    <div className="client_dashboard mt-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="mb-2">Client Dashboard</h1>
            <div className="content_area">
              <div className="tabs-container">
                {/* Render tab titles */}
                <div className="tabs">
                  {tabs.map((tab, index) => (
                    <button
                      key={index}
                      className={`tab ${activeTab === index ? "active" : ""}`}
                      onClick={() => setActiveTab(index)}
                    >
                      {tab.title}
                    </button>
                  ))}
                </div>

                {/* Render active tab content */}
                <div className="tab-content">{tabs[activeTab].content}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="header_area">
              <Search />
              <button className="btn btn_s">Create</button>
            </div>
            <div className="user_list page_overflow">
              <div className="items_overflow">
                {users.map((user) => (
                  <div key={user.id} className="card">
                    <div className="user_info">
                      <img src={user.profileImage} alt={user.name} />
                      <div className="text-info">
                        <h4 className="name">
                          {user.name}{" "}
                          <span className="message_number">
                            {user.messageCount}
                          </span>
                        </h4>
                        <p className="score">
                          Credit Score: {user.creditScore}
                        </p>
                        <p
                          className={`status ${
                            user.available ? "green" : "red"
                          }`}
                        >
                          {user.status}
                        </p>
                      </div>
                    </div>
                    <div className="icons_area">
                      <FaEye className="icons" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
